import { createContext, useContext } from 'react';
import { type SiteSettings } from '#app/queries/site-settings.query.ts';

// Create context with null as default
const SiteSettingsContext = createContext<SiteSettings | undefined | null>(null);

// Export the provider component
export const SiteSettingsProvider = SiteSettingsContext.Provider;

// Export a custom hook for easy access
export function useSiteSettings() {
    const context = useContext(SiteSettingsContext);
    return context;
}